import React from 'react'
import {
  Table,
  ButtonToolbar,
  ButtonGroup} from 'reactstrap';
import { Link } from 'react-static'
import ItemMenu from './ItemMenu'

export default ({clients,deleteClient}) =>
  <div className=" card-box table-responsive" >
    <ButtonToolbar className="justify-content-between">
      <ButtonGroup/>
      <ButtonGroup>
        <Link to='/clients/new' className="btn btn-success btn-sm btn-primary">Neuer Kunde</Link>
      </ButtonGroup>
    </ButtonToolbar>

    <Table striped className="m-t-20">
      <thead>
        <tr>
          <th align="left">Kundennummer</th>
          <th align="left">Name</th>
          <th align="left">Adresse</th>
          <th align="left">Erstellt am</th>
          <th align="left"/>
        </tr>
      </thead>
      <tbody>
        {!!clients && clients.map(client =>
          <tr key={client.id}>
            <td><Link to={`/clients/${client.id}/show`}>{client.number}</Link></td>
            <td>{client.name}</td>
            <td>{client.address}</td>
            <td>{client.createdAt}</td>
            <td>
              <ItemMenu>
                <Link className="dropdown-item" to={`/clients/${client.id}/show`}>Bearbeiten</Link>
                <a
                  className="dropdown-item"
                  href="#"
                  onClick={(e) => {e.preventDefault(); deleteProduct(product.id)}}>
                  Löschen
                </a>
              </ItemMenu>
            </td>
          </tr>
        )}
      </tbody>
    </Table>

  </div>



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/ClientList.js